import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AppointmentService {
  path: string = "api/Appointment/";
  constructor(private http: HttpClient) {}

  cancelAppointmentById(appointmentId: number): Observable<any> {
    return this.http.get(
      this.path + "CancelByReceptionnew?id=" + appointmentId
    );
  }
}
